/* assets/dz-tool.js.liquid
   Trading Card Centering Tool (email gate removed)
*/
(() => {
  const root = document.getElementById('dz-tool');
  if (!root) return;

  /* ---------- Upload: hidden input + drop zone (always unlocked) ---------- */
  const fileInput = root.querySelector('#file');
  const dropZone  = root.querySelector('#dropZone');
  function triggerUpload(){ if (fileInput) fileInput.click(); }

  if (dropZone){
    dropZone.addEventListener('click', triggerUpload);
    dropZone.addEventListener('keydown',(e)=>{
      if(e.key==='Enter' || e.key===' '){
        e.preventDefault();
        triggerUpload();
      }
    });
    ['dragenter','dragover'].forEach(ev =>
      dropZone.addEventListener(ev,(e)=>{ e.preventDefault(); dropZone.classList.add('dragover'); }, {passive:false})
    );
    ['dragleave','drop'].forEach(ev =>
      dropZone.addEventListener(ev,(e)=>{ e.preventDefault(); dropZone.classList.remove('dragover'); }, {passive:false})
    );
    dropZone.addEventListener('drop',(e)=>{
      const f = e.dataTransfer?.files?.[0];
      if(f && fileInput){
        const dt=new DataTransfer(); dt.items.add(f);
        fileInput.files=dt.files;
        fileInput.dispatchEvent(new Event('change',{bubbles:true}));
      }
    });
  }

  /* ---------- Guard against theme jump ---------- */
  (function guardInitialJump(){
    if (location.hash) history.replaceState(null, "", location.pathname + location.search);
    const top = window.scrollY; setTimeout(()=>{ window.scrollTo(0, top); }, 0);
  })();

  /* ---------- Tool state ---------- */
  const img = root.querySelector('#photo');
  const overlay = root.querySelector('#overlay');
  const handlesLayer = root.querySelector('#handles');
  const fitbox = root.querySelector('#fitbox');
  const viewport = root.querySelector('#viewport');

  // Auto mode radios
  let AUTO_MODE = 'default';
  const autoDefault = document.getElementById('autoDefault');
  const autoSmart   = document.getElementById('autoSmart');

  function setAutoRadio(mode){
    AUTO_MODE = (mode === 'smart') ? 'smart' : 'default';
    if (autoDefault) autoDefault.checked = (AUTO_MODE === 'default');
    if (autoSmart)   autoSmart.checked   = (AUTO_MODE === 'smart');
  }
  function enableAutoRadios(on){ [autoDefault, autoSmart].forEach(el => { if (el) el.disabled = !on; }); }
  enableAutoRadios(false);

  // Re-run detector when the radio changes
  if (autoDefault){
    autoDefault.addEventListener('change', e=>{
      if (!e.target.checked) return;
      setAutoRadio('default');
      smartAutoPlace('default');
    });
  }
  if (autoSmart){
    autoSmart.addEventListener('change', e=>{
      if (!e.target.checked) return;
      setAutoRadio('smart');
      smartAutoPlace('smart');
    });
  }

  if (handlesLayer){
    handlesLayer.style.pointerEvents = 'none';
    Array.from(handlesLayer.children).forEach(b => b.style.pointerEvents = 'auto');
  }

  const PLACEHOLDER = "https://cdn.shopify.com/s/files/1/0577/4399/9059/files/Upload_Photo_to_Get_Started.jpg?v=1755202327";
  let usingPlaceholder = true;

  let natW=0, natH=0, dispW=0, dispH=0, scale=1;
  let BADGE_W = 36, BADGE_H = Math.round(36*0.8), LINE_W = 2;
  let LINE_STYLE='dotted';
  let IMG_ZOOM = 1.0;
  let IMG_ROTATE = 0;

  const zoomValEl   = document.getElementById('zoomVal');
  const rotateValEl = document.getElementById('rotateVal');
  function refreshControlsUI(){
    if (zoomValEl)   zoomValEl.textContent   = Math.round(IMG_ZOOM * 100) + '%';
    if (rotateValEl) rotateValEl.textContent = IMG_ROTATE.toFixed(1) + '°';
  }
  function clamp(v, lo, hi){ return Math.max(lo, Math.min(hi, v)); }

  function applyZoom(delta){
    const prev = IMG_ZOOM;
    IMG_ZOOM = clamp(+(IMG_ZOOM + delta).toFixed(2), 1.0, 3.0);
    if (IMG_ZOOM !== prev){
      layoutFitbox(); drawAll(); positionBadges(); updateReadout();
      refreshControlsUI();
    }
  }
  function applyRotation(deltaDeg){
    const prev = IMG_ROTATE;
    IMG_ROTATE = clamp(+(IMG_ROTATE + deltaDeg).toFixed(1), -5.0, 5.0);
    if (IMG_ROTATE !== prev){
      img.style.transform = 'rotate(' + IMG_ROTATE + 'deg)';
      refreshControlsUI();
    }
  }
  function resetSettingsNoGuidelines(){
    IMG_ZOOM = 1.0; IMG_ROTATE = 0.0; img.style.transform = 'rotate(0deg)';
    layoutFitbox(); drawAll(); positionBadges(); updateReadout(); refreshControlsUI();
    if (typeof smartStatus !== 'undefined' && smartStatus) smartStatus.textContent = '—';
  }

  const SENS = {
    low:  { deadbandPx: 8, hysteresisPx: 8, maxStepImg: 2,   alpha: 0.25 },
    med:  { deadbandPx: 4, hysteresisPx: 4, maxStepImg: 6,   alpha: 0.55 },
    high: { deadbandPx: 1, hysteresisPx: 1, maxStepImg: 999, alpha: 1.00 }
  };
  let sensKey = 'high';

  const guides={ outer:{L:50,R:350,T:50,B:500}, pc:{L:80,R:320,T:90,B:460} };
  const hRatio=root.querySelector('#hRatio');
  const vRatio=root.querySelector('#vRatio');
  const gradeEl=root.querySelector('#grade');
  const smartStatus=root.querySelector('#smartStatus');

  function layoutFitbox(){
    if(!natW||!natH) return;
    const r=viewport.getBoundingClientRect();
    const base = Math.min(r.width/natW, r.height/natH);
    scale = base * IMG_ZOOM;

    dispW=Math.round(natW*scale);
    dispH=Math.round(natH*scale);
    const offX=Math.floor((r.width-dispW)/2);
    const offY=Math.floor((r.height-dispH)/2);

    fitbox.style.width=dispW+'px'; fitbox.style.height=dispH+'px';
    fitbox.style.left=offX+'px';   fitbox.style.top=offY+'px';

    const dpr=Math.max(1,window.devicePixelRatio||1);
    overlay.width=Math.floor(dpr*dispW); overlay.height=Math.floor(dpr*dispH);
    overlay.style.width=dispW+'px'; overlay.style.height=dispH+'px';
    overlay.getContext('2d').setTransform(dpr,0,0,dpr,0,0);

    handlesLayer.style.width=dispW+'px'; handlesLayer.style.height=dispH+'px';

    drawAll(); positionBadges();
  }

  const n2d_x=x=>Math.round(x*scale), n2d_y=y=>Math.round(y*scale);
  const d2n_x = x => x / Math.max(scale, 1e-6);
  const d2n_y = y => y / Math.max(scale, 1e-6);

  function clearOverlay(){ overlay.getContext('2d').clearRect(0,0,dispW,dispH); }
  function drawLineV(x, color){
    if(!natW || usingPlaceholder) return;
    const ctx=overlay.getContext('2d'); const px=n2d_x(x)+0.5;
    ctx.save(); ctx.strokeStyle=color; ctx.lineWidth=LINE_W; ctx.lineCap='round';
    ctx.setLineDash(LINE_STYLE==='dotted'?[2,3]:[]); ctx.beginPath();
    ctx.moveTo(px,0); ctx.lineTo(px,dispH); ctx.stroke(); ctx.restore();
  }
  function drawLineH(y, color){
    if(!natW || usingPlaceholder) return;
    const ctx=overlay.getContext('2d'); const py=n2d_y(y)+0.5;
    ctx.save(); ctx.strokeStyle=color; ctx.lineWidth=LINE_W; ctx.lineCap='round';
    ctx.setLineDash(LINE_STYLE==='dotted'?[2,3]:[]); ctx.beginPath();
    ctx.moveTo(0,py); ctx.lineTo(dispW,py); ctx.stroke(); ctx.restore();
  }
  function drawAll(){
    clearOverlay();
    if(usingPlaceholder) return;
    const o=guides.outer, p=guides.pc;
    drawLineV(p.L,'rgba(255,196,0,1)'); drawLineV(p.R,'rgba(255,196,0,1)');
    drawLineH(p.T,'rgba(255,196,0,1)'); drawLineH(p.B,'rgba(255,196,0,1)');
    drawLineV(o.L,'rgba(0,192,0,1)');   drawLineV(o.R,'rgba(0,192,0,1)');
    drawLineH(o.T,'rgba(0,192,0,1)');   drawLineH(o.B,'rgba(0,192,0,1)');
  }

  let _rafReadout = null;
  function updateReadout(){
    if (_rafReadout) cancelAnimationFrame(_rafReadout);
    _rafReadout = requestAnimationFrame(()=>{
      if(!natW || usingPlaceholder){
        hRatio.textContent='—'; vRatio.textContent='—'; gradeEl.textContent='—';
        return;
      }
      const o=guides.outer, p=guides.pc;
      const L=p.L-o.L, R=o.R-p.R, T=p.T-o.T, B=o.B-p.B;
      const split=(a,b)=>{ const s=Math.max(a+b,1e-6), x=Math.round(100*a/s); return [x,100-x]; };
      const [hL,hR]=split(L,R), [vT,vB]=split(T,B);
      const cls=hi=>hi<=55?'Balanced':(hi<=60?'Minor Shift':(hi<=65?'Noticeable Flaw':'Major Off-Center'));
      hRatio.textContent=(hL + '% / ' + hR + '% → ' + cls(Math.max(hL,hR)));
      vRatio.textContent=(vT + '% / ' + vB + '% → ' + cls(Math.max(vT,vB)));
      const worst=Math.max(Math.max(hL,hR),Math.max(vT,vB));
      gradeEl.textContent=(worst<=55)?'PSA 10':(worst<=60)?'PSA 9':(worst<=65)?'PSA 8':(worst<=70)?'PSA 7':'PSA 6 or lower (centering-only)';
    });
  }

  const B={
    outer_L:root.querySelector('#b_outer_L'),
    outer_R:root.querySelector('#b_outer_R'),
    outer_T:root.querySelector('#b_outer_T'),
    outer_B:root.querySelector('#b_outer_B'),
    pc_L:root.querySelector('#b_pc_L'),
    pc_R:root.querySelector('#b_pc_R'),
    pc_T:root.querySelector('#b_pc_T'),
    pc_B:root.querySelector('#b_pc_B'),
  };

  function positionBadges(){
    if(!natW || usingPlaceholder) return;
    const o=guides.outer, p=guides.pc;
    for(const el of Object.values(B)){ el.style.width=BADGE_W+'px'; el.style.height=Math.round(BADGE_W*.8)+'px'; }
    BADGE_H=Math.round(BADGE_W*.8);
    const vInset=1, hInset=1;
    const sepY=Math.max(6,Math.round(BADGE_H*.30)), sepX=Math.max(6,Math.round(BADGE_W*.30));
    const yAbove=Math.max(0,Math.min(Math.round(dispH/2-BADGE_H-sepY/2),dispH-BADGE_H));
    const yBelow=Math.max(0,Math.min(Math.round(dispH/2+sepY/2),dispH-BADGE_H));
    const xLeftC=Math.max(0,Math.min(Math.round(dispW/2-BADGE_W-sepX/2),dispW-BADGE_W));
    const xRightC=Math.max(0,Math.min(Math.round(dispW/2+sepX/2),dispW-BADGE_W));

    B.outer_L.style.left=Math.max(0,Math.min(n2d_x(o.L)+vInset,dispW-BADGE_W))+'px'; B.outer_L.style.top=yAbove+'px';
    B.pc_L.style.left=Math.max(0,Math.min(n2d_x(p.L)+vInset,dispW-BADGE_W))+'px';   B.pc_L.style.top=yBelow+'px';

    B.outer_R.style.left=Math.max(0,Math.min(n2d_x(o.R)-BADGE_W-vInset,dispW-BADGE_W))+'px'; B.outer_R.style.top=yAbove+'px';
    B.pc_R.style.left=Math.max(0,Math.min(n2d_x(p.R)-BADGE_W-vInset,dispW-BADGE_W))+'px';    B.pc_R.style.top=yBelow+'px';

    B.outer_T.style.left=xLeftC+'px'; B.outer_T.style.top=Math.max(0,Math.min(n2d_y(o.T)+hInset,dispH-BADGE_H))+'px';
    B.pc_T.style.left=xRightC+'px';   B.pc_T.style.top=Math.max(0,Math.min(n2d_y(p.T)+hInset,dispH-BADGE_H))+'px';

    B.outer_B.style.left=xLeftC+'px'; B.outer_B.style.top=Math.max(0,Math.min(n2d_y(o.B)-BADGE_H-hInset,dispH-BADGE_H))+'px';
    B.pc_B.style.left=xRightC+'px';   B.pc_B.style.top=Math.max(0,Math.min(n2d_y(p.B)-BADGE_H-hInset,dispH-BADGE_H))+'px';
  }

  function clampGuides(){
    if(!natW) return; const g=guides;
    g.outer.L=Math.max(0,Math.min(g.outer.L,natW-2));
    g.outer.R=Math.max(g.outer.L+1,Math.min(g.outer.R,natW-1));
    g.outer.T=Math.max(0,Math.min(g.outer.T,natH-2));
    g.outer.B=Math.max(g.outer.T+1,Math.min(g.outer.B,natH-1));
    g.pc.L=Math.max(g.outer.L,Math.min(g.pc.L,g.outer.R-1));
    g.pc.R=Math.max(g.pc.L+1,Math.min(g.pc.R,g.outer.R));
    g.pc.T=Math.max(g.outer.T,Math.min(g.pc.T,g.outer.B-1));
    g.pc.B=Math.max(g.pc.T+1,Math.min(g.pc.B,g.outer.B));
  }

  function wireBadge(el, axis, group, side){
    if(!el) return;
    let dragging=false, deltaToLine=0, startVal=0, lastEmitVal=0, committed=false;

    el.addEventListener('pointerdown', e=>{
      if(!natW || usingPlaceholder) return;
      dragging=true; committed=false; el.classList.add('dragging'); el.setPointerCapture(e.pointerId);
      const fb=fitbox.getBoundingClientRect();
      const lineVal=(group==='outer'?guides.outer:guides.pc)[side];
      const lineDisp=(axis==='x')?n2d_x(lineVal):n2d_y(lineVal);
      const cur=(axis==='x')?(e.clientX-fb.left):(e.clientY-fb.top);
      deltaToLine=lineDisp-cur; startVal=lineVal; lastEmitVal=lineVal;
      e.preventDefault();
    });

    window.addEventListener('pointermove', e=>{
      if(!dragging||!natW || usingPlaceholder) return;
      const fb=fitbox.getBoundingClientRect();
      const cur=(axis==='x')?(e.clientX-fb.left):(e.clientY-fb.top);
      let lineDisp=cur+deltaToLine;
      lineDisp=(axis==='x')?Math.max(0,Math.min(lineDisp,dispW)):Math.max(0,Math.min(lineDisp,dispH));

      const S = sensKey==='high'? SENS.high : sensKey==='med'? SENS.med : SENS.low;
      const movedPx = Math.abs((axis==='x'? n2d_x(lastEmitVal) : n2d_y(lastEmitVal)) - lineDisp);

      if (!committed){
        const fromStartPx = Math.abs((axis==='x'? n2d_x(startVal) : n2d_y(startVal)) - lineDisp);
        if (fromStartPx < S.hysteresisPx) return;
        committed = true;
      }
      if (movedPx < S.deadbandPx) return;

      let v = (axis==='x')? d2n_x(lineDisp) : d2n_y(lineDisp);
      const dv = v - lastEmitVal;
      const maxStep = S.maxStepImg;
      if (Math.abs(dv) > maxStep) v = lastEmitVal + Math.sign(dv) * maxStep;
      v = lastEmitVal + (v - lastEmitVal) * S.alpha;

      (group==='outer'?guides.outer:guides.pc)[side]=v;
      lastEmitVal = v;

      clampGuides();
      if(group==='outer'){ const g=guides;
        g.pc.L=Math.max(g.outer.L,Math.min(g.pc.L,g.outer.R-1));
        g.pc.R=Math.max(g.pc.L+1,Math.min(g.pc.R,g.outer.R));
        g.pc.T=Math.max(g.outer.T,Math.min(g.pc.T,g.outer.B-1));
        g.pc.B=Math.max(g.pc.T+1,Math.min(g.pc.B,g.outer.B)); }

      drawAll(); positionBadges(); updateReadout();
      e.preventDefault();
    }, {passive:false});

    function endDrag(){
      if(!dragging) return;
      dragging = false;
      el.classList.remove('dragging');
      clampGuides(); drawAll(); positionBadges(); updateReadout();
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
  }

  wireBadge(B.outer_L,'x','outer','L');
  wireBadge(B.outer_R,'x','outer','R');
  wireBadge(B.outer_T,'y','outer','T');
  wireBadge(B.outer_B,'y','outer','B');
  wireBadge(B.pc_L,'x','pc','L');
  wireBadge(B.pc_R,'x','pc','R');
  wireBadge(B.pc_T,'y','pc','T');
  wireBadge(B.pc_B,'y','pc','B');

  /* ---------- Smart/Default auto-place (unchanged) ---------- */
  async function smartAutoPlace(mode = 'default'){
    if (!natW || usingPlaceholder) return;
    if (smartStatus) smartStatus.textContent = 'Detecting…';

    // --- DEFAULT (bg-diff) ---
    if (mode === 'default') {
      const maxDim = 1300;
      const s = Math.min(1, maxDim / Math.max(natW, natH));
      const sw = Math.max(1, Math.round(natW * s));
      const sh = Math.max(1, Math.round(natH * s));

      const oc = document.createElement('canvas');
      oc.width = sw; oc.height = sh;
      const ox = oc.getContext('2d', { willReadFrequently: true });

      const tmp = new Image(); tmp.crossOrigin = 'anonymous';
      await new Promise(res => { tmp.onload = () => { ox.drawImage(tmp,0,0,sw,sh); res(); }; tmp.src = img.src; });

      function percentile(arr, p){
        const k = Math.max(0, Math.min(arr.length-1, Math.floor((arr.length-1)*p)));
        const copy = arr.slice().sort((a,b)=>a-b);
        return copy[k];
      }
      function sampleBackgroundRGBA(){
        const band = Math.max(2, Math.round(Math.min(sw, sh)*0.02));
        const id = ox.getImageData(0, 0, sw, sh);
        const data = id.data;
        const Rs=[],Gs=[],Bs=[];
        function push(i){ Rs.push(data[i]); Gs.push(data[i+1]); Bs.push(data[i+2]); }
        for(let y=0;y<band;y++){ let oT=y*sw*4,oB=(sh-1-y)*sw*4; for(let x=0;x<sw;x++){ push(oT+x*4); push(oB+x*4); } }
        for(let y=band;y<sh-band;y++){ let o=y*sw*4; push(o+0); push(o+(sw-1)*4); }
        const med=a=>percentile(a,.5);
        return [med(Rs), med(Gs), med(Bs)];
      }
      function buildMaskAndProjections(Rbg,Gbg,Bbg){
        const id = ox.getImageData(0,0,sw,sh);
        const D = new Float32Array(sw*sh);
        const Lbg = 0.299*Rbg+0.587*Gbg+0.114*Bbg;
        for(let i=0,j=0;i<id.data.length;i+=4,j++){
          const r=id.data[i], g=id.data[i+1], b=id.data[i+2];
          const l = 0.299*r+0.587*g+0.114*b;
          const dr=Math.abs(r-Rbg), dg=Math.abs(g-Gbg), db=Math.abs(b-Bbg);
          D[j]=dr+dg+db+Math.abs(l-Lbg)*0.5;
        }
        const sample=[]; for(let i=0;i<D.length;i+=16) sample.push(D[i]);
        const med=percentile(sample,.5), p90=percentile(sample,.9);
        const thr=Math.max(18, med + 0.35*(p90-med));

        // 3×3 mean
        const E=new Float32Array(D.length), w=sw,h=sh;
        for(let y=0;y<h;y++){
          for(let x=0;x<w;x++){
            let acc=0,cnt=0;
            for(let dy=-1;dy<=1;dy++){
              const yy=y+dy; if(yy<0||yy>=h) continue;
              const off=yy*w;
              for(let dx=-1;dx<=1;dx++){
                const xx=x+dx; if(xx<0||xx>=w) continue;
                acc+=D[off+xx]; cnt++;
              }
            }
            E[y*w+x]=acc/cnt;
          }
        }
        const mask=new Uint8Array(D.length); for(let i=0;i<E.length;i++) mask[i]=E[i]>thr?1:0;

        const col=new Float32Array(w), row=new Float32Array(h);
        for(let y=0;y<h;y++){ let off=y*w; for(let x=0;x<w;x++){ const m=mask[off+x]; col[x]+=m; row[y]+=m; } }
        return { col, row };
      }
      function findEdgesFromProjection(arr, minPct, refineWin=8){
        const n=arr.length; let maxV=0; for(let i=0;i<n;i++) if(arr[i]>maxV) maxV=arr[i];
        const cutoff=maxV*minPct;
        let left=0;  while(left<n  && arr[left] <cutoff) left++;
        let right=n-1;while(right>=0 && arr[right]<cutoff) right--;
        if(left>=right) return {left:0,right:n-1,conf:0};

        const der=new Float32Array(n); for(let i=1;i<n;i++) der[i]=arr[i]-arr[i-1];
        const clampI=i=>Math.max(0,Math.min(n-1,i));
        const refine=idx=>{
          const a=clampI(idx-refineWin), b=clampI(idx+refineWin);
          let bestI=idx,best=-1e9; for(let i=a;i<=b;i++){ if(der[i]>best){best=der[i];bestI=i;} }
          return bestI;
        };
        const L=refine(left), R=refine(right);
        const avg=(maxV/(n||1));
        const conf=Math.min(4,Math.max(.5,(der[L]-(-der[R]))/Math.max(1e-3,avg)));
        return {left:L,right:R,conf};
      }

      const bg = sampleBackgroundRGBA();
      const pr = buildMaskAndProjections(bg[0],bg[1],bg[2]);
      const colRes = findEdgesFromProjection(pr.col, 0.12);
      const rowRes = findEdgesFromProjection(pr.row, 0.12);

      const toImgX = x => Math.round(x / s);
      const toImgY = y => Math.round(y / s);

      let L=toImgX(colRes.left), R=toImgX(colRes.right),
          T=toImgY(rowRes.left), B=toImgY(rowRes.right);

      const widthOK  = (R-L) > natW*0.35;
      const heightOK = (B-T) > natH*0.35;
      const conf     = Math.min(colRes.conf, rowRes.conf);

      let used = false;
      if (widthOK && heightOK && conf >= 1.1){
        L=Math.max(0,L+1); R=Math.min(natW-1,R-1);
        T=Math.max(0,T+1); B=Math.min(natH-1,B-1);
        guides.outer = {L,R,T,B}; used = true;
      } else {
        const ix=Math.round(natW*0.02), iy=Math.round(natH*0.02);
        guides.outer = { L:ix, R:natW-ix, T:iy, B:natH-iy };
      }

      // simple inner inset
      const Wout=guides.outer.R-guides.outer.L, Hout=guides.outer.B-guides.outer.T;
      const px=Math.round(Wout*0.06), py=Math.round(Hout*0.06);
      guides.pc = {
        L: guides.outer.L+px, R: guides.outer.R-px,
        T: guides.outer.T+py, B: guides.outer.B-py
      };

      clampGuides(); positionBadges(); drawAll(); updateReadout();
      if (smartStatus) smartStatus.textContent = 'Default: outer ' + (used?'OK':'fallback') + ', inner simple inset';
      return;
    }

    // --- SMART (as implemented previously) ---
    const C = {
      maxDim: 1600, bandPct: 0.025, edgePct: 0.10, minPct: 0.10,
      projSmoothR: 6, sobelRescue: true, confMin: 1.0, thrK: 0.35, thrMin: 16
    };

    function percentile(arr, p){
      if(!arr || !arr.length) return 0;
      const k = Math.max(0, Math.min(arr.length-1, Math.floor((arr.length-1)*p)));
      const copy = arr.slice().sort((a,b)=>a-b);
      return copy[k];
    }
    function boxSmooth1D(src,radius){ const n=src.length, dst=new Float32Array(n); for(let i=0;i<n;i++){ let a=i-radius, b=i+radius; if(a<0)a=0; if(b>=n)b=n-1; let sum=0; for(let j=a;j<=b;j++) sum+=src[j]; dst[i]=sum/(b-a+1);} return dst; }
    function deriv1D(src){ const n=src.length, d=new Float32Array(n); for(let i=1;i<n;i++) d[i]=src[i]-src[i-1]; d[0]=d[1]||0; return d; }
    function maxIdx(a,s,e){ const start=s<0?0:s, end=e>=a.length?a.length-1:e; let best=start, bestV=-1e9; for(let i=start;i<=end;i++){ if(a[i]>bestV){ bestV=a[i]; best=i; } } return best; }

    const s = Math.min(1, C.maxDim / Math.max(natW, natH));
    const sw = Math.max(1, Math.round(natW * s));
    const sh = Math.max(1, Math.round(natH * s));

    const oc = document.createElement('canvas'); oc.width = sw; oc.height = sh;
    const ox = oc.getContext('2d', { willReadFrequently: true });

    const tmp = new Image(); tmp.crossOrigin = 'anonymous';
    await new Promise(res => { tmp.onload = () => { ox.drawImage(tmp, 0, 0, sw, sh); res(); }; tmp.src = img.src; });

    const id0 = ox.getImageData(0,0,sw,sh), data=id0.data;

    const band = Math.max(2, Math.round(Math.min(sw, sh)*C.bandPct));
    const Rs=[], Gs=[], Bs=[], Ls=[];
    function pushPix(i){ const r=data[i], g=data[i+1], b=data[i+2]; const l=0.299*r+0.587*g+0.114*b; Rs.push(r); Gs.push(g); Bs.push(b); Ls.push(l); }
    for(let y=0;y<band;y++){ const oT=y*sw*4, oB=(sh-1-y)*sw*4; for(let x=0;x<sw;x++){ pushPix(oT+x*4); pushPix(oB+x*4); } }
    for(let y=band;y<sh-band;y++){ const o=y*sw*4; pushPix(o); pushPix(o+(sw-1)*4); }
    const Rb=percentile(Rs,.5), Gb=percentile(Gs,.5), Bb=percentile(Bs,.5), Lb=percentile(Ls,.5);

    const D = new Float32Array(sw*sh);
    for(let j=0,i4=0;j<D.length;j++,i4+=4){
      const r=data[i4], g=data[i4+1], b=data[i4+2];
      const l=0.299*r+0.587*g+0.114*b;
      D[j]=Math.abs(r-Rb)+Math.abs(g-Gb)+Math.abs(b-Bb)+0.5*Math.abs(l-Lb);
    }
    const E = new Float32Array(D.length);
    for(let y=0;y<sh;y++){
      for(let x=0;x<sw;x++){
        let sum=0,cnt=0;
        for(let dy=-1;dy<=1;dy++){
          const yy=y+dy; if(yy<0||yy>=sh) continue;
          const off=yy*sw;
          for(let dx=-1;dx<=1;dx++){
            const xx=x+dx; if(xx<0||xx>=sw) continue;
            sum+=D[off+xx]; cnt++;
          }
        }
        E[y*sw+x]=sum/cnt;
      }
    }

    const samp=[]; for(let t=0;t<E.length;t+=16) samp.push(E[t]);
    const med=percentile(samp,.5), p90=percentile(samp,.9);
    const thr=Math.max(C.thrMin, med + C.thrK*(p90-med));

    let col=new Float32Array(sw), row=new Float32Array(sh);
    for(let y=0;y<sh;y++){ const offy=y*sw; for(let x=0;x<sw;x++){ const m = E[offy+x]>thr ? 1 : 0; col[x]+=m; row[y]+=m; } }
    const xa=Math.floor(sw*C.edgePct), xb=Math.ceil(sw*(1-C.edgePct));
    const ya=Math.floor(sh*C.edgePct), yb=Math.ceil(sh*(1-C.edgePct));
    for(let x=0;x<sw;x++) col[x]*=(x<xa||x>xb)?0.65:1;
    for(let y=0;y<sh;y++) row[y]*=(y<ya||y>yb)?0.65:1;
    col=boxSmooth1D(col, C.projSmoothR);
    row=boxSmooth1D(row, C.projSmoothR);

    function findEdgesFromProjection(arr, minPct, win){
      const n=arr.length; let maxV=0; for(let i=0;i<n;i++) if(arr[i]>maxV) maxV=arr[i];
      const cutoff=maxV*minPct;
      let L=0;  while(L<n  && arr[L] <cutoff) L++;
      let R=n-1;while(R>=0 && arr[R]<cutoff) R--;
      if(L>=R) return {left:0,right:n-1,conf:0};
      const d = deriv1D(arr);
      const Lr = maxIdx(d, Math.max(0,L-win), Math.min(n-1,L+win));
      const negD = new Float32Array(n); for(let i=0;i<n;i++) negD[i] = -d[i];
      const Rr = maxIdx(negD, Math.max(0,R-win), Math.min(n-1,R+win));
      const avg = Math.max(1e-3, (arr.reduce((a,b)=>a+b,0)/n));
      const leftStr  = Math.abs(d[Lr]);
      const rightStr = Math.abs(d[Rr]);
      const conf = Math.min(4, Math.max(0.5, (leftStr+rightStr)/(2*avg)));
      return {left:Lr, right:Rr, conf:conf};
    }

    const colRes = findEdgesFromProjection(col, C.minPct, 10);
    const rowRes = findEdgesFromProjection(row, C.minPct, 10);

    const toImgX = x => Math.round(x / s);
    const toImgY = y => Math.round(y / s);

    let L = toImgX(colRes.left),  R = toImgX(colRes.right);
    let T = toImgY(rowRes.left),  B = toImgY(rowRes.right);

    // Sobel rescue
    let usedSobel = false;
    function sobelRescueRun(){
      let used=false, x0=Math.floor(sw*0.04), x1=Math.ceil(sw*0.96),
          y0=Math.floor(sh*0.04), y1=Math.ceil(sh*0.96);

      const Gx=[-1,0,1,-2,0,2,-1,0,1], Gy=[-1,-2,-1,0,0,0,1,2,1];
      let magCol=new Float32Array(sw), magRow=new Float32Array(sh);

      for(let y=y0+1;y<y1-1;y++){
        for(let x=x0+1;x<x1-1;x++){
          let sx=0, sy=0, k=0;
          for(let dy=-1;dy<=1;dy++){
            const yy=y+dy;
            for(let dx=-1;dx<=1;dx++){
              const xx=x+dx, ii=(yy*sw+xx)*4;
              const r=data[ii], g=data[ii+1], b=data[ii+2];
              const l=(r+g+b)/3;
              sx += l*Gx[k]; sy += l*Gy[k]; k++;
            }
          }
          const m=Math.sqrt(sx*sx+sy*sy);
          magCol[x]+=m; magRow[y]+=m;
        }
      }
      magCol=boxSmooth1D(magCol,6); magRow=boxSmooth1D(magRow,6);
      const dC=deriv1D(magCol), dR=deriv1D(magRow);
      const LL=maxIdx(dC, Math.floor(x0), Math.floor((x0+x1)/2));
      const RR=maxIdx((()=>{const a=new Float32Array(dC.length); for(let i=0;i<dC.length;i++) a[i]=-dC[i]; return a;})(),
                      Math.floor((x0+x1)/2), x1-1);
      const TT=maxIdx(dR, Math.floor(y0), Math.floor((y0+y1)/2));
      const RRneg=(()=>{const a=new Float32Array(dR.length); for(let i=0;i<dR.length;i++) a[i]=-dR[i]; return a;})()
      const BB=maxIdx(RRneg, Math.floor((y0+y1)/2), y1-1);

      const wOK=(RR-LL)>(sw*0.35), hOK=(BB-TT)>(sh*0.35);
      if(wOK && hOK){ L=toImgX(LL); R=toImgX(RR); T=toImgY(TT); B=toImgY(BB); used=true; }
      return used;
    }

    const widthOK  = (R-L) > natW*0.35;
    const heightOK = (B-T) > natH*0.35;
    const conf = Math.min(colRes.conf, rowRes.conf);

    if(!(widthOK && heightOK && conf >= C.confMin)){
      if (C.sobelRescue) usedSobel = sobelRescueRun();
      if(!usedSobel){
        const ix=Math.round(natW*0.02), iy=Math.round(natH*0.02);
        L=ix; R=natW-ix; T=iy; B=natH-iy;
      }
    }

    // aspect-ratio clamp near 2.5x3.5 (0.714)
    const targetAR=0.714, tolLo=0.60, tolHi=0.82;
    const w = R-L, h = B-T, ar = w/Math.max(1,h);
    if(ar<tolLo || ar>tolHi){
      const cx=(L+R)/2;
      let newW=Math.round(targetAR*h);
      newW = Math.max(Math.round(0.45*natW), Math.min(newW, Math.round(0.98*natW)));
      L=Math.round(cx-newW/2); R=L+newW;
      if(L<0){ R-=L; L=0; }
      if(R>natW-1){ L-= (R-(natW-1)); R=natW-1; }
    }

    // clamp edges slightly inward
    L = Math.max(0, Math.min(L+1, natW-2));
    R = Math.max(1, Math.min(R-1, natW-1));
    T = Math.max(0, Math.min(T+1, natH-2));
    B = Math.max(1, Math.min(B-1, natH-1));
    guides.outer = {L,R,T,B};

    // inner via local gradient search
    const Wout=R-L, Hout=B-T;
    const fc=document.createElement('canvas'); fc.width=natW; fc.height=natH;
    const ctxFull=fc.getContext('2d',{willReadFrequently:true});
    try{ ctxFull.drawImage(img,0,0,natW,natH); }catch(_){}
    let idFull=null; try{ idFull = ctxFull.getImageData(0,0,natW,natH); }catch(_){}

    function findInnerVertical(x0,x1, y0,y1){
      if(!idFull) return Math.round((x0+x1)/2);
      const d=idFull.data; let bestX=x0, best=-1e9;
      for(let x=x0;x<=x1;x++){
        let ssum=0,cnt=0;
        for(let y=y0+1;y<=y1-1;y++){
          const i1=(y*natW + (x-1))*4, i2=(y*natW + (x+1))*4;
          if(i1<0||i2>=d.length) continue;
          const l1=(d[i1]+d[i1+1]+d[i1+2])/3, l2=(d[i2]+d[i2+1]+d[i2+2])/3;
          ssum+=Math.abs(l2-l1); cnt++;
        }
        const v = cnt? ssum/cnt : 0;
        if(v>best){ best=v; bestX=x; }
      }
      return bestX;
    }
    function findInnerHorizontal(y0,y1, x0,x1){
      if(!idFull) return Math.round((y0+y1)/2);
      const d=idFull.data; let bestY=y0, best=-1e9;
      for(let y=y0;y<=y1;y++){
        let ssum=0,cnt=0;
        for(let x=x0+1;x<=x1-1;x++){
          const i1=((y-1)*natW + x)*4, i2=((y+1)*natW + x)*4;
          if(i1<0||i2>=d.length) continue;
          const l1=(d[i1]+d[i1+1]+d[i1+2])/3, l2=(d[i2]+d[i2+1]+d[i2+2])/3;
          ssum+=Math.abs(l2-l1); cnt++;
        }
        const v = cnt? ssum/cnt : 0;
        if(v>best){ best=v; bestY=y; }
      }
      return bestY;
    }

    const lx0=L+Math.round(Wout*0.03), lx1=L+Math.round(Wout*0.12);
    const rx0=R-Math.round(Wout*0.12), rx1=R-Math.round(Wout*0.03);
    const ty0=T+Math.round(Hout*0.03), ty1=T+Math.round(Hout*0.12);
    const by0=B-Math.round(Hout*0.12), by1=B-Math.round(Hout*0.03);

    const pL=findInnerVertical(lx0,lx1, T,B);
    const pR=findInnerVertical(rx0,rx1, T,B);
    const pT=findInnerHorizontal(ty0,ty1, L,R);
    const pB=findInnerHorizontal(by0,by1, L,R);

    const minInsetW=Math.round(Wout*0.02), minInsetH=Math.round(Hout*0.02);
    const ok = (pL>L+minInsetW) && (pR<R-minInsetW) && (pT>T+minInsetH) && (pB<B-minInsetH) && (pL<pR) && (pT<pB);

    if(ok){
      guides.pc = { L:pL, R:pR, T:pT, B:pB };
    } else {
      const px=Math.round(Wout*0.06), py=Math.round(Hout*0.06);
      guides.pc = { L:L+px, R:R-px, T:T+py, B:B-py };
    }

    clampGuides(); positionBadges(); drawAll(); updateReadout();
    if (smartStatus){
      const srcStr = (widthOK && heightOK && conf >= C.confMin) ? 'bg-mask' : (usedSobel ? 'bg+sobel' : 'fallback');
      smartStatus.textContent = 'Smart: outer ' + srcStr + ', inner gradient';
    }
  }

  function resetGuides(){
    if(!natW || usingPlaceholder) return;
    guides.outer={L:Math.round(natW*0.02),R:Math.round(natW*0.98),T:Math.round(natH*0.02),B:Math.round(natH*0.98)};
    guides.pc   ={L:Math.round(natW*0.06),R:Math.round(natW*0.94),T:Math.round(natH*0.06),B:Math.round(natH*0.94)};
    clampGuides(); positionBadges(); drawAll(); updateReadout(); if (smartStatus) smartStatus.textContent='—';
  }

  /* Image loader */
  function loadImage(src, asPlaceholder){
    const img = document.getElementById('photo');
    img.crossOrigin = "anonymous";
    if (!asPlaceholder){
      usingPlaceholder = false;
      const sb = document.getElementById('smartBtn');
      if (sb) sb.disabled = true;
      handlesLayer.style.display = 'none';
    }

    let finalized = false;
    function finalize(){
      if (finalized) return; finalized = true;
      natW = img.naturalWidth; natH = img.naturalHeight;
      if (!natW || !natH) return;

      try { img.setAttribute('width', String(natW)); img.setAttribute('height', String(natH)); } catch(e){}

      layoutFitbox();

      if (asPlaceholder){
        usingPlaceholder = true;
        handlesLayer.style.display = 'none';
        const sb = document.getElementById('smartBtn'); if (sb) sb.disabled = true;
        clearOverlay(); if (hRatio) hRatio.textContent = '—'; if (vRatio) vRatio.textContent = '—'; if (gradeEl) gradeEl.textContent = '—';
        setAutoRadio('default'); enableAutoRadios(false);
        return;
      } else {
        usingPlaceholder = false;
        handlesLayer.style.display = 'block';
        const sb = document.getElementById('smartBtn'); if (sb) sb.disabled = false;
        setAutoRadio('default'); enableAutoRadios(true);
        resetGuides();
        requestAnimationFrame(function(){ smartAutoPlace(AUTO_MODE); });

        // Scroll toolbar into view (nice UX)
        try{
          var tb = document.getElementById('stageToolbar');
          if (tb){
            var pad = 12;
            var sticky = document.querySelector('[data-sticky-header], .shopify-section-header-sticky, .site-header, header[role="banner"]');
            var fixedTop = 0;
            if (sticky){
              var cs = getComputedStyle(sticky);
              if (cs.position === 'fixed' || /sticky/i.test(sticky.className)) {
                fixedTop = sticky.getBoundingClientRect().height || 0;
              }
            }
            var y = tb.getBoundingClientRect().top + window.pageYOffset - (fixedTop + pad);
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }catch(e){}
      }
    }

    img.onload = async function(){
      try{ if ('decode' in img && typeof img.decode === 'function'){ await img.decode(); } }catch(_){}
      finalize();
    };
    setTimeout(finalize, 800);
    img.src = src;
  }

  // Start with placeholder
  loadImage(PLACEHOLDER, true);

  if (fileInput){
    fileInput.addEventListener('change', e=>{
      const f=e.target.files?.[0]; if(!f) return;
      resetSettingsNoGuidelines();
      setAutoRadio('default'); enableAutoRadios(false);
      const url=URL.createObjectURL(f);
      usingPlaceholder=false; const sb=document.getElementById('smartBtn'); if(sb) sb.disabled=true; handlesLayer.style.display='none';
      loadImage(url, false);
    });
  }

  /* Toolbar buttons */
  const zoomMinus = document.getElementById('zoomMinus');
  const zoomPlus  = document.getElementById('zoomPlus');
  const rotMinus  = document.getElementById('rotMinus');
  const rotPlus   = document.getElementById('rotPlus');

  if (zoomMinus) zoomMinus.addEventListener('click', ()=> applyZoom(-0.10));
  if (zoomPlus)  zoomPlus .addEventListener('click', ()=> applyZoom(+0.10));
  if (rotMinus)  rotMinus .addEventListener('click', ()=> applyRotation(-0.5));
  if (rotPlus)   rotPlus  .addEventListener('click', ()=> applyRotation(+0.5));

  /* Settings modal (unchanged) */
  const settingsModal = document.getElementById('dz-settings');
  const settingsOpen  = document.getElementById('openSettings');
  function openSettings(){ if (settingsModal){ settingsModal.classList.remove('dz-hidden'); settingsModal.setAttribute('aria-hidden','false'); } }
  function closeSettings(){ if (settingsModal){ settingsModal.classList.add('dz-hidden'); settingsModal.setAttribute('aria-hidden','true'); } }
  if (settingsOpen) settingsOpen.addEventListener('click', openSettings);
  if (settingsModal){
    settingsModal.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', closeSettings));
    settingsModal.addEventListener('click', (e)=>{ if (e.target.matches('.dz-modal__scrim')) closeSettings(); });
    document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeSettings(); });
  }

  /* Reset Settings */
  const resetSettingsBtn = root.querySelector('#resetSettingsBtn');
  if (resetSettingsBtn) resetSettingsBtn.addEventListener('click', resetSettingsNoGuidelines);

  /* Smart Auto-Place button */
  const smartBtn = document.getElementById('smartBtn');
  if (smartBtn) smartBtn.addEventListener('click', ()=> smartAutoPlace(AUTO_MODE));

  /* Option controls */
  const handleW=document.getElementById('handleW');
  const lineW=document.getElementById('lineW');

  if (handleW) handleW.addEventListener('input', function(){
    BADGE_W=parseInt(handleW.value,10); BADGE_H=Math.round(BADGE_W*.8);
    const v=document.getElementById('handleWVal'); if (v) v.textContent=BADGE_W+'px';
    positionBadges();
  });
  if (lineW) lineW.addEventListener('input', function(){
    LINE_W=parseInt(lineW.value,10); const v=document.getElementById('lineWVal'); if (v) v.textContent=LINE_W+'px';
    drawAll(); positionBadges();
  });

  document.querySelectorAll('input[name="style"]').forEach(function(r){
    r.addEventListener('change', function(){ if(r.checked){ LINE_STYLE=r.value; drawAll(); } });
  });

  // ---- Sensitivity radios (Low / Med / High) ----
  const sensRadios = Array.from(document.querySelectorAll('input[name="sens"]'));

  function setSensitivity(val){
    sensKey = (val === 'low' || val === 'med') ? val : 'high';
    sensRadios.forEach(r => r.checked = (r.value === sensKey));
    try { localStorage.setItem('dz_sens', sensKey); } catch(_) {}
  }

  try {
    const saved = localStorage.getItem('dz_sens');
    if (saved) setSensitivity(saved);
  } catch(_){}

  sensRadios.forEach(r => {
    r.addEventListener('change', () => { if (r.checked) setSensitivity(r.value); });
  });

  window.addEventListener('resize', function(){ if(natW) layoutFitbox(); });

  refreshControlsUI();
})();
